import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, extractError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AcceptInvitePage() {
    const [sp] = useSearchParams();
    const token = sp.get("token") || "";
    const [info, setInfo] = useState(null);
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState(null);
    const { refreshMe } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) { setErr("No invite token"); return; }
        api.get(`/auth/invite/${token}`).then(({ data }) => setInfo(data)).catch((e) => setErr(extractError(e)));
    }, [token]);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/accept-invite", { token, name, password });
            await refreshMe();
            toast.success("Welcome aboard");
            navigate("/dashboard");
        } catch (er) {
            toast.error(extractError(er));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 auth-grid-bg">
            <div className="w-full max-w-md brut-section p-10" data-testid="invite-card">
                <div className="label-overline mb-2">Invitation</div>
                <h1 className="text-3xl font-bold tracking-tight mb-3">Join your team</h1>
                {err && <div className="text-sm text-destructive">{err}</div>}
                {info && !err && (
                    <>
                        <p className="text-sm text-muted-foreground mb-8">
                            You're being invited to <strong>{info.org_name}</strong> as <strong>{info.role?.replace("_"," ")}</strong>.
                        </p>
                        <form onSubmit={onSubmit} className="space-y-5">
                            <div>
                                <Label className="label-overline">Email</Label>
                                <Input value={info.email} readOnly className="mt-2 rounded-sm h-11 bg-secondary" data-testid="invite-email" />
                            </div>
                            <div>
                                <Label className="label-overline">Your name</Label>
                                <Input value={name} onChange={(e) => setName(e.target.value)} required className="mt-2 rounded-sm h-11" data-testid="invite-name-input" />
                            </div>
                            <div>
                                <Label className="label-overline">Password</Label>
                                <Input type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 rounded-sm h-11" data-testid="invite-password-input" />
                            </div>
                            <Button type="submit" disabled={loading} className="w-full rounded-sm h-11 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="invite-submit-button">
                                {loading ? "Accepting..." : "Accept & sign in"}
                            </Button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
